import './Hotspot.scss'
import { useHistory } from 'react-router-dom'
import React, { useState, useEffect } from "react";
import { Link } from '@material-ui/core';


function changeColor(){
    alert("hi there!");
}
const lists=[
    {id :1, title:"Control Panel Solutions"},
    {id :2, title:"Industrial Computing"},
    {id :3, title:"Machine Safety"},
    {id :4, title:"Motion Controls"},
    {id :5, title:"Networking"},
    {id :6, title:"Operator Interface + HMI"},
    {id :7, title:"Power Monitoring"},
    {id :8, title:"Sensors"},
    {id :9, title:"Cybersecurity"},
    {id :10, title:"Pneumatics"},
    {id :11, title:"IIotSolutions"},
    {id :12, title:"Drives"}
]

export function Hotspot(props) {// click code 
    let history = useHistory()
    const path = `/ia-graphic/solution/${props.content.link}`

    return (
        <div className="lg-hotspot" >
            <div
                className='lg-hotspot__dot'
                onClick={() =>
                        history.push(path)
                    }  
                style={{ top: props.top, left: props.left, backgroundColor: props.isLit ? "#2DB7FF": "" }}
            >
                {/* Labels of each icon */}
                <label className="icon-label" id="vert-align">
                {props.content.label[2]}
                </label>
            </div>
            {/* To show hovering of icon */}
            <label className="on-hover-icon" style={{ top: props.content.pos[0], left: props.content.pos[1] }}>
                {props.content.name}
            </label>
        </div>
        
        
    )
}

export function HotspotLegend(props) {
    let history = useHistory()
    const path = `/ia-graphic/solution/${props.content.link}`
    return (
        <div className="lg-hotspot-legend">
            <div
                className='lg-hotspot__dot-legend'
                onClick={() => 
                    history.push(path)
                }
                style={{ top: props.top, left: props.left, backgroundColor: props.isLit ? "#2DB7FF": "" }}
            >
                {/* Labels of each icon */}
                <label className="icon-label-legend" id="vert-align">
                    {props.content.label[2]}
                </label>
            </div>
            {/* To show hovering of icon */}
            <label className="on-hover-icon" style={{ top: props.content.pos[0], left: props.content.pos[1], display: props.isLit? 'block' : 'none' }}>
                {props.content.name}
            </label>
        </div>
    )
}